module.exports = __webpack_public_path__ + "img/diamond.ed724c0f.png";